import { Box, Typography } from '@mui/material';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../utils/constants';

const columns = (renderValueCell, properties, dialogParameter, hydraulicParameterData, renderModelCell) => {
  // const hideEQLosses = properties.some(row => Number(row.flow_in || 0) !== 0);

  // const hideROP = hydraulicParameterData.some(item => item.parameter === 'ROP');
  // const hideRPM = hydraulicParameterData.some(item => item.parameter === 'RPM');
  const hideHoleDepth = hydraulicParameterData.some(item => item.parameter === 'Hole Depth');
  // const hideFlowRate = hydraulicParameterData.some(item => item.parameter === 'Flow Rate');

  return [
    {
      field: 'rheo_model',
      headerName: 'Model',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Model
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderModelCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      hide: true
    },
    {
      field: 'hole_depth',
      headerName: 'Hole Depth (ft)',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Hole
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Depth (ft)
          </Typography>
        </Box>
      ),
      flex: 1,
      hide: hideHoleDepth,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(2));
      },
    },
    {
      field: 'bit_depth',
      headerName: 'Bit Depth (ft)',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Bit
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Depth (ft)
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 40,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(2));
      },
    },
    {
      field: 'bit_depth_offset',
      headerName: 'Bit Depth Offset (ft)',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Bit Depth
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Offset (ft)
          </Typography>
        </Box>
      ),
      flex: 1,
      hide: !hideHoleDepth,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      headerAlign: 'center',
      align: 'center',
      valueFormatter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(2));
      },
    },
    {
      field: 'rop',
      headerName: 'ROP (ft/hr)',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 20,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(2));
      },
    },
    {
      field: 'rpm',
      headerName: 'RPM (rpm)',
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(0));
      },
    },
    {
      field: 'flow_in',
      headerName: 'Flow Rate (gpm)',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Flow
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Rate (gpm)
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 10,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(0));
      },
    },
    {
      field: 'sbp',
      headerName: 'SBP (psi)',
      flex: 1,
      hide: false,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(0));
      },
    },
    {
      field: 'eq_losses',
      headerName: 'Equipment Losses (psi)',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Equipment
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Losses (psi)
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 50,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      hide: true,
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return parseFloat(value.toFixed(0));
      },
    },
    {
      field: 'correction_factor',
      headerName: 'Correction Factor',
      renderHeader: () => (
        <Box>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Correction
          </Typography>
          <Typography sx={{ fontSize: '1.2rem' }}>
            Factor
          </Typography>
        </Box>
      ),
      flex: 1,
      minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
      maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
      renderEditCell: renderValueCell,
      editable: true,
      headerAlign: 'center',
      align: 'center',
      hide: true,
      valueGetter: (params) => {
        if (params.value === null || params.value === undefined || params.value === '') {
          return '';
        }
        const value = Number(params.value);
        if (isNaN(value)) {
          return params.value;
        }
        return value;
      },
    },
  ];
};
export default columns;
